import { defineAction } from '../utils/defineAction';

const INIT = 'INIT';
const SUCCESS = 'SUCCESS';
const ERROR = 'ERROR';

const httpActions = [INIT, SUCCESS, ERROR];

export const HPS_REPLACE = defineAction(
  'HPS_REPLACE',
  ['CHANGE_STEP', 'VERIFY_PATIENT_INFO', 'CLEAR'],
);

export const SUBMIT_HPS_REPLACE_FORM = defineAction(
  'SUBMIT_HPS_REPLACE_FORM',
  httpActions,
);
